import { Component, OnInit, ViewChild } from '@angular/core';
import { LeaseRestoration } from '../../service/leaseResoration.service';
import { ExcelServiceService } from '../../service/excelService';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';




@Component({
  selector: 'dda-lr-dashboard',
  templateUrl: './lr-dashboard.component.html',
  styleUrls: ['./lr-dashboard.component.scss']
})
export class LrDashboardComponent implements OnInit {

  displayedColumns = ['id', 'applicationNo', 'createdDate', 'updatedDate', 'branchName', 'status'];
  remarkDisplayedColumns = ['applicationId', 'actionDate', 'status', 'description'];
  branchDisplayedColumns: string[] = ['srNo', 'branchName', 'count'];

  misData = new MatTableDataSource<any>();
  remarkList: any[] = [];

  showBranchwiseTable = false;
branchwiseData: any[] = [];


  dataSource: [];
  header = [];




  isProcessHistoryView = false;
  selectedAppNo = '';

  constructor(private leaseService: LeaseRestoration, private excelService: ExcelServiceService) { }
  @ViewChild('mainPaginator') mainPaginator: MatPaginator;
  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.leaseService.getLeaseRestorationMISRecords({}).subscribe((res) => {
      this.misData = new MatTableDataSource(res);
      this.misData.paginator = this.mainPaginator;
    });
  }

  showProcessHistory(appNo: string) {
    debugger
    this.selectedAppNo = appNo;
    this.isProcessHistoryView = true;
    this.leaseService.getLeaseRestorationWorkFlowRemarkHistory(appNo).subscribe(data => {
      this.remarkList = data; // No paginator used
    });
  }

  goBack() {
    this.isProcessHistoryView = false;
    this.selectedAppNo = '';
    this.remarkList = [];
     this.showBranchwiseTable = false;
  }

  export() {
    const filteredData = this.misData.filteredData;
    const todayDate = new Date().toLocaleDateString();
    const header = ['Application Number', 'Created Date', 'Updated Date', 'Branch Name', 'Status'];
    this.excelService.exportToExcel(header, filteredData, 'Lease_Report_' + todayDate, 'sheet1');
  }

 fetchBranchwiseCount() {
  const payload = {}; // Add filters here if needed
  this.leaseService.fetchBranchwiseCount(payload).subscribe(
    (data: any[]) => {
      this.branchwiseData = data;
      this.showBranchwiseTable = true;
    },
    error => {
      console.error('Error fetching branchwise count', error);
    }
  );

}
}
